import utils from '../utils'
import api from '../apis'
export default {
    state: {
        WorkTask: {},
        AdviseList: []
    },
    getters: {
        WorkTask(state) {
            return state.WorkTask;
        },
        AdviseList(state) {
            return state.AdviseList
        }
    },
    mutations: {
        setWorkTask(state, WorkTask) {
            state.WorkTask = WorkTask;
        },
        setAdviseList(state, AdviseList) {
            state.AdviseList = AdviseList;
        },
    },
    actions: {
        loadWorkTask(
            context) {
            let commit = context.commit;
            let isSupply = context.getters.isSupply
            if (isSupply) {
                function getWorkTasks() {
                    let data = {
                        "KeyWords": "",
                        "CreateTime": "",
                        "CreateTimeEnd": "",
                        "OrderStatus": "",
                        "ProductType": "",
                        "PageNo": 1,
                        "PageSize": 999999999,
                        "RecordCount": 0,
                        "ServiceType": "",
                        "BusinessStatus": '',
                        "BusinessStatuss": [10107, 10105, 10109, 10203],
                        "BusinessTypes": [1797, 1789, 1799],
                        "BusinessType": "",
                        "ServiceTypes": [1407, 1409, 1470],// 1408 旅游不统计
                    }
                    api.work.getWorkTasks(data, {
                            failTips: false
                        }).then(function (json) {
                        // console.log(json)
                        if (!json||!json.data|| !json.data.isSucc) {
                            return json;
                        }
                        commit('setWorkTask', json.data.result);
                        return json;
                    });
                }
                getWorkTasks();

            }
        },
        loadAdviseList(context) {
            let commit = context.commit;
            let isSupply = context.getters.isSupply
            if (isSupply) {
                function getAdviseList() {
                    let data = {
                        PageNo: 1,
                        PageSize: 9999999999,
                        RecordCount: 0,
                        AdviseID: '',
                        AdviseType: '',
                        ContactPhone: '',
                    }
                    api.adapter.getAdviseList(data).then(function (json) {
                        if (!json.data.isSucc) {
                            return json;
                        }
                        commit('setAdviseList', json.data.result.entities);
                        return json;
                    });
                }
                getAdviseList();

            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/workTaskStore.js